'use client';

import { useEffect } from 'react';
import { useStores } from '@/store/hooks/useStore';

/**
 * 工具设置初始化组件
 *
 * 职责：
 * 1. 在应用启动时自动加载工具设置
 * 2. 不渲染任何 UI，纯粹的副作用组件
 *
 * 使用方式：
 * 在 app/providers.tsx 中引入此组件
 */
export function ToolSettingsInitializer() {
  const stores = useStores();
  const fetchToolSettings = stores.threadToolStore.fetchToolSettings;

  useEffect(() => {
    fetchToolSettings();
  }, []);

  return null;
}
